import { Fragment } from 'react';
import { observer } from 'mobx-react';
import Grid from '@mui/material/Grid';
import { makeStyles } from '@mui/styles';

import './App.css';
import './Okretanje.css';
import './Pulsiranje.css';
import Krunica from './components/Krunica';
import KrunicaBozanskogMilosrda from './components/KrunicaBozanskogMilosrda';
import Menu from './components/Menu';
import Navigacija from './components/Navigacija';
import Povratak from './components/Povratak';
import MolitvaBlazenogOca from 'components/MolitvaBlazenogOca';
import { storeKrunica } from './store/KrunicaStore';
import MolitvaOsobnogPredanja from 'components/MolitvaOsobnogPredanja';
import KrunicaPobjede from 'components/KrunicaPobjede';
import KrunicaAndeoska from 'components/KrunicaAndeoska';

const useStyles = makeStyles((theme) => ({
  container: {
    position: 'relative',
    height: '100vh',
    margin: '0',
    overflowX: 'hidden',
    overflowy: 'hidden',
    [theme.breakpoints.up('sm')]: {
      backgroundColor: '#e9e9e9',
      border: '1px solid #ece7e7',
      height: '100vh',
    },
  },
  zaglavlje: {
    fontSize: '1.2rem',
    marginTop: '2rem',
  },
}));

function App() {
  const classes = useStyles();
  const { zrno, prijevodOtajstvatext, trenutnaKrunica, aktivnaZemlja } =
    storeKrunica;
  const { krunice } = aktivnaZemlja;
  const nePrikazi = [-1, 0, 16, 27, 38, 49, 60].includes(zrno);
  const prikaziNavigaciju = ['blazenogOca', 'osobnaPredanje'].includes(
    trenutnaKrunica,
  );
  // console.log('trenutnaKrunica', trenutnaKrunica);

  return (
    <Fragment>
      <Grid item xs={12} sm alignItems="center" className={classes.container}>
        <Menu />
        {trenutnaKrunica === 'blazenogOca' && <MolitvaBlazenogOca />}
        {trenutnaKrunica === 'osobnaPredanje' && <MolitvaOsobnogPredanja />}
        {trenutnaKrunica === 'bozijeMilosrde' && <KrunicaBozanskogMilosrda />}
        {trenutnaKrunica === 'pobjede' && <KrunicaPobjede />}
        {trenutnaKrunica === 'andeoska' && <KrunicaAndeoska />}
        {trenutnaKrunica === 'gospa' && <Krunica />}
        {trenutnaKrunica === 'rita' && <Krunica />}
        {trenutnaKrunica === 'gertruda' && <Krunica />}
        {!prikaziNavigaciju && (
          <Fragment>
            <Povratak
              povratak={
                trenutnaKrunica === 'pobjede'
                  ? 59
                  : trenutnaKrunica === 'bozijeMilosrde'
                    ? 60
                    : trenutnaKrunica === 'rita'
                      ? 60
                      : 61
              }
            />
            <Navigacija />
            {!nePrikazi && trenutnaKrunica === 'gospa' && (
              <div className={classes.zaglavlje}>
                <span>{prijevodOtajstvatext} †</span>
              </div>
            )}
            {!nePrikazi && trenutnaKrunica === 'rita' && (
              <div className={classes.zaglavlje}>
                <span>
                  {krunice.find((k) => k.value === trenutnaKrunica)?.label} †
                </span>
              </div>
            )}
          </Fragment>
        )}
      </Grid>
    </Fragment>
  );
}

export default observer(App);
